import { useEffect, useRef } from 'react';

import { useEditorInlineCommentsPubSub as usePubsub } from '@confluence/comments-pubsub/entry-points/inlineComments';
type PubSubProps = {
	contentId: string;
	contentType: string;
	triggerAnalyticsEvent: (
		eventName: string,
		extraData?: {
			[key: string]: any;
		},
	) => Promise<void>;
	updateUnresolvedInlineComment: (unresolvedInlineComments: string[]) => void;
	isEnabled?: boolean;
	isDocumentActive?: boolean;
};

export const useEditorInlineCommentsPubSub = ({
	contentId,
	contentType,
	triggerAnalyticsEvent,
	updateUnresolvedInlineComment,
	isEnabled = true,
	isDocumentActive,
}: PubSubProps) => {
	const isRegistered = useRef(false);

	const { register, unregister } = usePubsub({
		contentId,
		triggerAnalyticsEvent,
		updateUnresolvedInlineComment,
		contentType,
	});

	useEffect(() => {
		if (isEnabled && !isRegistered.current) {
			register();
			isRegistered.current = true;

			return () => {
				unregister();
				isRegistered.current = false;
			};
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isEnabled, register, unregister, isDocumentActive]);
};
